import { Header } from 'header'
import { Seo, MapTags as View } from 'ui-components'

import { TagsFilters } from './TagsFilters'
import { TagsPagination } from './TagsPagination'
import { TagsView } from './TagsView'

export function App(props) {
  const { page = 1, hasNextPage = false } = props

  return (
    <>
      <Seo
        title={`Tags - Tag page ${page}`}
        description={`Viewing page ${page} of our tags.`}
        additionalLinkTags={[
          ...(page > 1
            ? [
                {
                  rel: 'prev',
                  href: `/tags?page=${page - 1}`
                }
              ]
            : []),
          ...(hasNextPage
            ? [
                {
                  rel: 'next',
                  href: `/tags?page=${page + 1}`
                }
              ]
            : [])
        ]}
      />

      <View
        slots={{
          Header,
          TagsFilters,
          TagsView,
          TagsPagination
        }}
      />
    </>
  )
}
